import { useCallback } from 'react';

type TSelectableItem = {
  id: string;
};

type TSelectActiveItemParams<T extends TSelectableItem> = {
  activeItem: T | null;
  setActiveItem: React.Dispatch<React.SetStateAction<T | null>>;
};

/**
 * Selects `item` as the active one, ignoring a re-selection of the item that is
 * already active so its in-progress UI state is not thrown away.
 *
 * Websocket presence is not handled here: it is leased from the active item
 * itself in `BroadcastScheduleProgramContextProvider`. See `usePresenceLease`.
 */
export function useSelectActiveItem<T extends TSelectableItem>({
  activeItem,
  setActiveItem,
}: TSelectActiveItemParams<T>) {
  return useCallback(
    (item: T) => {
      if (activeItem && activeItem.id === item.id) {
        return;
      }
      setActiveItem(item);
    },
    [activeItem, setActiveItem]
  );
}
